/** Compatibility export; the business domain owns this implementation. */
export { IPodDesign } from '@domains/upload/shared';
